import config from './config/degree'
import axios from '@/utils/request'

export const educationTagList = params => axios.post(config.educationTagList, params)
export const educationTagCreate = params => axios.post(config.educationTagCreate, params)
export const educationTagEdit = params => axios.post(config.educationTagEdit, params)
export const educationTagBatchDelete = params => axios.post(config.educationTagBatchDelete, params)
export const educationStatusUpdate = params => axios.post(config.educationStatusUpdate, params)

export const degreeSignUpList = params => axios.post(config.degreeSignUpList, params)
export const degreeSignUpDetailExport = params =>
  axios.post(config.degreeSignUpDetailExport, params, { responseType: 'blob' })
export const degreeSignUpListExport = params =>
  axios.post(config.degreeSignUpListExport, params, { responseType: 'blob' })
export const degreeProductQrCode = params => axios.post(config.degreeProductQrCode, params)
export const degreeEnrollDetail = params => axios.post(config.degreeEnrollDetail, params)
export const degreeMaterialUpdate = params => axios.post(config.degreeMaterialUpdate, params)
export const degreeMaterialSubmit = params => axios.post(config.degreeMaterialSubmit, params)
export const degreeProductEnrollCheck = params =>
  axios.post(config.degreeProductEnrollCheck, params)
